import EkomApi from '../api/EkomApi'
import { FETCH_INTERVAL_KEY, useFetchInterval } from './useFetchInterval'

export const useCountUnreadIncoming = () => {
  return useFetchInterval<number>(EkomApi.getCountUnreadIncoming, FETCH_INTERVAL_KEY.IN)
}
